import React from 'react';
import {
  useUpdateScreenCandidateMutation,
  useGetScreenCandDetailsQuery,
} from '../../../../../features/hiringstages/screeningApiSlice';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import { useLocationQuery } from '../../../../../features/location/locationApiSlice';

const CandidateExpectation = ({ setShowNotification }) => {
  const [updateScreenCandidate, { isLoading }] =
    useUpdateScreenCandidateMutation();
  const selectedCand = useSelector((data) => data.candidate);
  const {
    data: canddetails,
    error: canddetailsErr,
    isLoading: canddetailsLoading,
    isFetching: canddetailsFetching,
    isSuccess: canddetailsSuccess,
    // data,
  } = useGetScreenCandDetailsQuery(selectedCand, {
    refetchOnMountOrArgChange: true,
  });
  const {
    data: locations,
    error: locationsErr,
    isLoading: locationsLoading,
    isFetching: locationsFetching,
    isSuccess: locationsSuccess,
  } = useLocationQuery({refetchOnMountOrArgChange: true});
console.log('locations',locations);
  // const updateSkillsRating = async () => {
  //   let values = {
  //     profile_id: canddetails?.data.id,
  //     buyout_option: 1,
  //     location_preferred: 'Chennai',
  //     other_details: "I don't like to join startup company ",
  //     screening_feedback: 'test',
  //   };
  //   try {
  //     const updateCandidateData = await updateCandidate(values).unwrap();
  //     setShowNotification(true);
  //     onModalDataClose();
  //   } catch (error) {
  //     console.log('error ', error);
  //   }
  // };

  const initialValues = {
    profile_id: canddetails?.data.id,
    buyout_option: canddetails?.data.buyout_option || 2,
    location_preferred: canddetails?.data.location_preferred || '',
    other_details: canddetails?.data.other_details || '',
    notice_period: canddetails?.data.notice_period || 0,
    salary_expectation: canddetails?.data.salary_expectation || 0,
  };

  const validationSchema = yup.object({
    // profile_id: canddetails?.data.id,
    buyout_option: yup.string().required('Please select buying options'),
    location_preferred: yup
      .string()
      .required('Please enter preferred location'),
    other_details: yup.string().required('Please enter other details'),
    notice_period: yup
      .number()
      .required('Please enter notice period')
      .positive('Please enter only Positive number'),
    salary_expectation: yup
      .number()
      .required('Please enter salary expectation')
      .positive('Please enter only Positive number'),
  });

  const onSubmit = async (validationSchema) => {
    try {
      const updateCandidateData = await updateScreenCandidate(
        validationSchema
      ).unwrap();

      setShowNotification(true);
      // onModalDataClose();
    } catch (error) {}
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="bg-white rounded-md shadow-3xl border border-gray-100 mt-5 px-5 py-3">
        <div className="col-span-4 sm:col-span-1">
          <label
            htmlFor="salary_expectation"
            className="block text-lg font-medium text-gray-700"
          >
            Expected Salary
          </label>
          <input
            type="text"
            name="salary_expectation"
            id="salary_expectation"
            autoComplete="cc-salary_expectation"
            className="bg-inputbg border border-inputBorder mt-1 block w-24 rounded-md  py-1 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
            placeholder="25 L"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.salary_expectation}
          />
          {formik.touched.salary_expectation &&
          formik.errors.salary_expectation ? (
            <div className="mt-2 text-sm w-full text-red-600">
              {formik.errors.salary_expectation}
            </div>
          ) : null}
        </div>

        <div className="col-span-4 sm:col-span-1 mt-2">
          <label
            htmlFor="notice_period"
            className="block text-lg font-medium text-gray-700"
          >
            Notice Period (in days)
          </label>
          <input
            type="text"
            name="notice_period"
            id="notice_period"
            autoComplete="cc-notice_period"
            className="bg-inputbg border border-inputBorder mt-1 block w-24 rounded-md  py-1 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
            placeholder="30 Days"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notice_period}
          />
          {formik.touched.notice_period && formik.errors.notice_period ? (
            <div className="mt-2 text-sm w-full text-red-600">
              {formik.errors.notice_period}
            </div>
          ) : null}
        </div>

        <div className="col-span-4 sm:col-span-1 mt-2">
          <label
            htmlFor="buyout_option"
            className="block text-lg font-medium text-gray-700"
          >
            Buyout Option
          </label>
          <select
            id="buyout_option"
            name="buyout_option"
            autoComplete="buyout_option"
            className=" bg-inputbg border border-inputBorder mt-0 w-24 rounded-md  py-1 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.buyout_option}
          >
            <option value={1}>Yes</option>
            <option value={2}>No</option>
          </select>
        </div>
        {formik.touched.buyout_option && formik.errors.buyout_option ? (
          <div className="mt-2 text-sm w-full text-red-600">
            {formik.errors.buyout_option}
          </div>
        ) : null}

        <div className="col-span-4 sm:col-span-1 mt-2">
          <label
            htmlFor="location_preferred"
            className="block text-lg font-medium text-gray-700"
          >
            Location Preferred
          </label>
          {/* <select
            id="location_preferred"
            name="location_preferred"
            autoComplete="location_preferred"
            className=" bg-inputbg border border-inputBorder mt-0 w-36 rounded-md  py-1 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.location_preferred}
          >
            <option value="">-- Select location --</option>
            <option>Chennai</option>
            <option>Bangalore</option>
            <option>Coimbatore</option>
          </select> */}
                  { locationsSuccess ? (
            <>
            <select
              id= "location_preferred"
              name= "location_preferred"
              className=" bg-inputbg border border-inputBorder mt-0 w-36 rounded-md  py-1 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
              onChange= {formik.handleChange}
              onBlur= {formik.handleBlur}
              value= {formik.values.location_preferred}
              >
              <option value="">-- Select location --</option>
              {locations && 
                locations?.data &&
                locations?.data.map((location) => (
                  <option value={location.id} key={location.id}>
                    {location.name}
                  </option>
                ))}
            </select>
            </>
          ) : (
            ''
          )}
        </div>
    
        {formik.touched.location_preferred &&
        formik.errors.location_preferred ? (
          <div className="mt-2 text-sm w-full text-red-600">
            {formik.errors.location_preferred}
          </div>
        ) : null}

        <div className="col-span-4 sm:col-span-1 mt-2">
          <label
            htmlFor="other_details"
            className="block text-lg font-medium text-gray-700"
          >
            Other Details
          </label>
          <textarea
            rows={4}
            name="other_details"
            id="other_details"
            className="block w-full bg-inputbg appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.other_details}
          />
          {formik.touched.other_details && formik.errors.other_details ? (
            <div className="mt-2 text-sm w-full text-red-600">
              {formik.errors.other_details}
            </div>
          ) : null}
        </div>
        <div className="flex justify-end">
          {/* <div>
            <button
              type="button"
              className="inline-flex  justify-center rounded-md border border-indigo-700 bg-white px-4 mt-4 mb-1 py-2 mr-2 text-base font-medium text-indigo-700 shadow-sm focus:outline-none  sm:col-start-2 sm:text-sm"
            >
              Close
            </button>
          </div> */}
          <button
            type="submit"
            className="inline-flex  justify-center rounded-md border border-transparent bg-indigo-600 px-4 mt-4 mb-1 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <svg
                  role="status"
                  className="inline mr-3 w-4 h-4 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>{' '}
                Saving...
              </>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CandidateExpectation;
